import { EditAssessmentModal } from './EditAssessmentModal';
import { useAssessmentQuery } from '@common/cache';

interface IEditAssessmentProps {
  assessment_id: string;
  patient_id: string;
  handleClose: () => void;
}

export const EditAssessment = ({
  assessment_id,
  patient_id,
  handleClose,
}: IEditAssessmentProps) => {
  const assessmentQuery = useAssessmentQuery({
    assessment_id,
    patient_id,
  });

  const extendedHandleClose = () => {
    assessmentQuery.refetch();
    handleClose();
  };

  return (
    assessmentQuery.data && (
      <EditAssessmentModal
        patient_id={patient_id}
        handleClose={extendedHandleClose}
        assessment={assessmentQuery.data}
      />
    )
  );
};
